"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var LoginPanelState_1 = require("./LoginPanelState");
var localStyles = require("./LoginPanel.scss");
var cms_integration_1 = require("@idp/cms-integration");
var Utils = require("../../../utils/UtilityFunctions");
var CartUtilFunctions_1 = require("../../../utils/CartUtilFunctions");
var ui_components_1 = require("@idp/ui-components");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var utils_1 = require("@idp/ui-components/utils");
var loginPanel_cms_1 = require("./loginPanel.cms");
var components_1 = require("@idp/login-ui/components");
var LoginConsoleProps_1 = require("@idp/login-ui/components/LoginConsole/LoginConsoleProps");
var CartInit_1 = require("@idp/cart-initializer/CartInit");
var StateProvider_1 = require("../../../api/StateProvider");
var cartStyles = require("../../CartConfigurationContainer/CartConfiguration.scss");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var ReportingService_1 = require("../../../api/ReportingService");
var event_bus_1 = require("@idp/event-bus");
var localdatastore_1 = require("../../../config/localdatastore");
var routables_1 = require("@idp/routables");
var components_2 = require("@idp/duc/components");
var LoginPanel = /** @class */ (function (_super) {
    __extends(LoginPanel, _super);
    function LoginPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new LoginPanelState_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.bindThistoFunctions();
        _this.reportingService = new ReportingService_1.default();
        return _this;
    }
    LoginPanel.prototype.componentDidMount = function () {
        this.id = event_bus_1.ICCEventBusManager.getUUID();
        this.registerLoginRequiredState();
        this.payload = Utils.getCartResp();
        this.cmsContent = new loginPanel_cms_1.LoginPanelCms();
        this.sisFoCMSData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common.sisfoOrder;
        this.bindThistoFunctions();
        var currentLob = Utils.getCurrentLOB();
        if (currentLob) {
            var finalLob = currentLob.toLowerCase().concat('Cart');
            this.finalLobOrigin = this.payload[finalLob];
        }
        if (this.payload) {
            this.setState({
                displayLoginMessage: this.payload.displayLoginOption,
            });
            this.isRequiredLogin = this.payload.requiredLogin;
        }
    };
    LoginPanel.prototype.componentWillUnmount = function () {
        event_bus_1.ICCEventBusManager.getInstance().deregisterObserver(this.id);
    };
    LoginPanel.prototype.render = function () {
        this.sisFoCMSData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common.sisfoOrder;
        return (React.createElement("div", null,
            this.state.displayLoginMessage && this.renderLoginMessage(),
            this.state.displayLoginPanel && this.renderLoginPanel()));
    };
    LoginPanel.prototype.bindThistoFunctions = function () {
        this.renderLoginMessage = this.renderLoginMessage.bind(this);
        this.renderLoginPanel = this.renderLoginPanel.bind(this);
        this.loginLinkClicked = this.loginLinkClicked.bind(this);
        this.onAuthentication = this.onAuthentication.bind(this);
        this.addQueriesToURL = this.addQueriesToURL.bind(this);
        this.registerLoginRequiredState = this.registerLoginRequiredState.bind(this);
        this.loginDisplayHandler = this.loginDisplayHandler.bind(this);
        this.getSisfoLabel = this.getSisfoLabel.bind(this);
    };
    LoginPanel.prototype.renderLoginMessage = function () {
        var icon = (React.createElement(components_2.IconSvg, { ariaHidden: false, ariaLabel: "Hi", svgNodeStr: Utils.GET_ICON_SVG.HI, colorClass: "color-ui-white", size: 32 }));
        var contextData = {
            className: localStyles.bannerStyle,
            icon: icon,
            text: this.sisFoCMSData.isRequiredLoginMessage,
        };
        var sisfoDisplayText = this.getSisfoLabel(); // old this.props.data.sisfoDisplayText;
        return (React.createElement("div", { className: localStyles.panelContainer },
            !this.isRequiredLogin &&
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: localStyles.contentContainer },
                        React.createElement("div", { className: cartStyles.firstlabelSisfo },
                            React.createElement(ui_components_1.Label, { data: {
                                    text: sisfoDisplayText ?
                                        this.sisFoCMSData.sisfoAvailableNewMessageLabel +
                                            ' ' + this.props.data.sisfoDisplayText : '',
                                } })),
                        React.createElement("div", { className: localStyles.sisfoLoginRequestMessage },
                            React.createElement(ui_components_1.Label, { data: {
                                    text: this.sisFoCMSData.sisfoLoginRequestMessage,
                                } })))),
            this.isRequiredLogin &&
                React.createElement("div", { className: localStyles.contentContainer },
                    React.createElement("div", { className: localStyles.buttonsDiv },
                        React.createElement("div", { className: localStyles.iconMessage },
                            React.createElement("div", { className: localStyles.iconWidth }, icon),
                            React.createElement("div", { className: "color-ui-white type-sm" },
                                React.createElement(ui_components_1.Label, { data: { text: contextData.text }, options: { size: LabelProps_1.LabelSizes.MEDIUM, className: localStyles.iconMessageSpace } }))),
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Button, { testId: utils_1.default('Link', 'LOGIN_LINK'), data: { text: this.sisFoCMSData.signInButtonMessage }, options: { className: localStyles.buttonStyles }, events: { onClick: this.loginLinkClicked } }))))));
    };
    LoginPanel.prototype.renderLoginPanel = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(components_1.LoginConsole, { data: {
                    channel: 'sales',
                    intent: LoginConsoleProps_1.FlowType.ACCOUNT_IN_FOCUS,
                }, options: {
                    suppressCreateOneLink: true,
                    suppressHeader: false,
                    suppressSavedId: true,
                    suppressSkipAuthLink: true,
                }, events: { isAuthenticated: this.onAuthentication } }),
            React.createElement("div", { className: localStyles.solidLine, "aria-hidden": "true" })));
    };
    LoginPanel.prototype.loginLinkClicked = function () {
        if (this.props && this.props.data && this.props.data.redirectToLoginURL && typeof window !== undefined) {
            var redirectLoginURL = this.props.data.redirectToLoginURL;
            this.reportingService.fireLinkClickWithOutPageLoad(this.sisFoCMSData.signInButtonMessage, redirectLoginURL);
            window.location.href = redirectLoginURL;
        }
        else {
            this.reportingService.fireLinkClickWithOutPageLoad(this.sisFoCMSData.signInButtonMessage, ReportingService_1.PageUrls.CART);
            this.setState({
                displayLoginMessage: false,
                displayLoginPanel: true,
            });
        }
    };
    LoginPanel.prototype.onAuthentication = function (authenticated, cancelled) {
        var _this = this;
        if (cancelled) {
            this.setState({
                displayLoginMessage: true,
                displayLoginPanel: false,
            });
        }
        if (authenticated) {
            this.addQueriesToURL();
            var sessionId = this.stateManager.get(localdatastore_1.getNamespace('APPSHELL'), 'sid');
            var sessionIdVal = '';
            if (sessionId && sessionId.value) {
                sessionIdVal = sessionId.value;
            }
            this.stateManager.set('displayLoginSuccess', { displaySuccessMessage: true });
            new CartInit_1.default().initializeCartApi('appShell:csrf-token', sessionIdVal)
                .then(function () {
                _this.stateManager.set('cartUpdate', { cartRefresh: true });
            })
                .catch(function () {
                _this.stateManager.set('cartUpdate', { cartRefresh: true });
            });
        }
    };
    LoginPanel.prototype.addQueriesToURL = function () {
        var url = location.href;
        var queryParams = url.indexOf('?') > -1 ? '?' + url.split('?')[1] : '?';
        if (!(CartUtilFunctions_1.isQueryInURL(location.href, 'retrievecart=true') ||
            CartUtilFunctions_1.isQueryInURL(location.href, 'retrieveCart=true'))) {
            queryParams = queryParams + '&retrievecart=true';
        }
        routables_1.history.push(queryParams);
    };
    LoginPanel.prototype.registerLoginRequiredState = function () {
        var _this = this;
        var checkoutObserver = {
            eventHandler: function () { _this.loginDisplayHandler(); },
            observerId: this.id,
            serviceName: 'appShell:actionsRequired',
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(checkoutObserver);
    };
    LoginPanel.prototype.loginDisplayHandler = function () {
        var loginRequest = this.stateManager.get(localdatastore_1.getNamespace('APPSHELL'), 'actionsRequired');
        if (loginRequest && loginRequest.login && loginRequest.login.toString().toUpperCase() === 'TRUE') {
            this.setState({
                displayLoginMessage: false,
                displayLoginPanel: true,
            }, function () {
                window.scrollTo({
                    behavior: 'smooth',
                    left: 0,
                    top: 0,
                });
            });
        }
    };
    LoginPanel.prototype.getSisfoLabel = function () {
        var text = '';
        if (this.payload
            && this.payload.sisfoStoreDetail) {
            if (this.finalLobOrigin && this.finalLobOrigin._cartOrigin &&
                this.finalLobOrigin._cartOrigin.toUpperCase() === 'OPUS-CARE') {
                text = this.sisFoCMSData.sicfoAvailableBodyMessageLabel;
            }
            else {
                var storeName = this.payload.sisfoStoreDetail.storeName;
                var agentName_1 = '';
                if (this.finalLobOrigin) {
                    var logsList_1 = this.finalLobOrigin.losgs;
                    if (logsList_1) {
                        Object.keys(logsList_1).forEach(function (losgKey) {
                            var losg = logsList_1[losgKey];
                            if (losg && losg.compensation) {
                                Object.keys(losg.compensation).forEach(function (repDetails) {
                                    if (losg.compensation[repDetails] && losg.compensation[repDetails][0]) {
                                        agentName_1 = losg.compensation[repDetails][0]._agentFirstName;
                                    }
                                });
                            }
                        });
                    }
                }
                var dynTxtArry = [
                    { textVal: "<b>" + storeName + "</b>", replacewith: 'Y' },
                    { textVal: "<b>" + agentName_1 + "</b>", replacewith: 'X' },
                ];
                text = Utils.cmsDynamicContent(this.sisFoCMSData.sisfoAvailableBodyMessageLabel, dynTxtArry);
            }
        }
        return text;
    };
    return LoginPanel;
}(React.Component));
exports.default = LoginPanel;
//# sourceMappingURL=LoginPanel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/LoginPanel/LoginPanel.js
// module id = 2381
// module chunks = 8